<template>
  <section id="contact" class="contact">
    <div class="container">
      <h1>Contact</h1>
      <div class="contact__details">
        <div class="contact__details__address">
          <p><b>Address: </b></p>
          <p>12 Suikerriet street,</p>
          <p>Nelspruit, South Africa</p>
        </div>
        <div class="contact__details__information">
          <p><b>Tel: </b><a v-hover href="tel:0825121349">082 512 1349</a></p>
          <p><b>Email: </b><a v-hover href="mailto:hi@consultancysquad.co.za">hi@consultancysquad.co.za</a></p>
          <!--<ul class="contact__details__social">
            <li>
              <a href="www.linkedin.com">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.832 28">
                  <path d="M27.834,2H4.118A2.03,2.03,0,0,0,2.06,4V28a2.03,2.03,0,0,0,2.058,2H27.834a2.03,2.03,0,0,0,2.058-2V4a2.03,2.03,0,0,0-2.058-2ZM10.5,25.436H6.3v-12.6h4.2ZM8.4,11.072h0A2.184,2.184,0,1,1,8.4,6.7a2.2,2.2,0,1,1,0,4.368ZM25.65,25.436h-4.2V18.674c0-1.694-.6-2.8-2.128-2.8A2.31,2.31,0,0,0,17.166,17.4a2.8,2.8,0,0,0-.14,1.022v7h-4.2v-12.6h4.2V14.6a4.2,4.2,0,0,1,3.794-2.1c2.8,0,4.83,1.806,4.83,5.684Z" transform="translate(-2.06 -2)"/>
                </svg>
              </a>
            </li>
            <li>
              <a href="www.facebook.com">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.5 28.5">
                  <path d="M28.932,2H3.567A1.567,1.567,0,0,0,2,3.567V28.932A1.568,1.568,0,0,0,3.568,30.5H17.219V19.456h-3.7V15.181h3.7V11.975a5.187,5.187,0,0,1,5.529-5.7,28.871,28.871,0,0,1,3.32.171v3.847H23.8c-1.8,0-2.138.855-2.138,2.095v2.75H25.94l-.556,4.275H21.665V30.5h7.267A1.567,1.567,0,0,0,30.5,28.932V3.567A1.567,1.567,0,0,0,28.932,2Z" transform="translate(-2 -2)"/>
                </svg>
              </a>
            </li>
            <li>
              <a href="www.twitter.com">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.511 23.21">
                  <path d="M30.511,6.63a12.1,12.1,0,0,1-3.364.912,5.888,5.888,0,0,0,2.58-3.236,11.7,11.7,0,0,1-3.721,1.426,5.845,5.845,0,0,0-9.979,5.332A16.593,16.593,0,0,1,3.982,4.948,5.93,5.93,0,0,0,3.2,7.9,5.83,5.83,0,0,0,5.792,12.76a5.773,5.773,0,0,1-2.652-.727V12.1a5.845,5.845,0,0,0,4.7,5.7,5.6,5.6,0,0,1-1.568.242,6.985,6.985,0,0,1-1.1-.1A5.859,5.859,0,0,0,10.639,22a11.718,11.718,0,0,1-7.213,2.509A11.3,11.3,0,0,1,2,24.421a16.494,16.494,0,0,0,8.967,2.637A16.522,16.522,0,0,0,27.66,10.408V9.652A12.017,12.017,0,0,0,30.511,6.63Z" transform="translate(-2 -3.849)"/>
                </svg>
              </a>
            </li>
          </ul>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss">
@import "../../assets/styles/breakpoints";
@import '../../assets/styles/variables';
.contact {
  h1 {
    position: relative;
    display: block;
    font-size: 50px;
    line-height: 50px;
    color: $indigo;
    text-align: center;
    left: 0;
    font-family: 'Autography', Courier, monospace;
    margin-bottom: 100px;
    @include breakpoint(sm) {
      font-size: 40px;
    }
    &:after {
      display: block;
      position: absolute;
      z-index: -10;
      top: 50%;
      width: 100%;
      height: 75px;
      content: '';
      background: $accent-block;
    }
  }
  .contact__details {
    margin: 100px 0 0;
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 1px 1px;
    grid-template-areas: ". .";
    padding-bottom: 40px;
    border-bottom: 1px solid rgba($sage, 0.5%);
    @include breakpoint(sm) {
      grid-template-columns: 100%;
      gap: 0px;
      grid-template-areas: ".";
    }
    p {
      font-weight: 300;
      @include breakpoint(sm) {
        text-align: center;
      }
      a {
        transition: color .2s ease-in-out;
        &:hover {
          color: $sage;
        }
      }
    }
    .contact__details__address {
      border-right: 1px solid rgba($sage, 0.5%);
      padding: 40px 0px;
      @include breakpoint(sm) {
        width: 100%;
        border-right: none;
      }
    }
    .contact__details__information {
      padding: 40px 0 40px 40px;
      @include breakpoint(sm) {
        padding: 0;
      }
    }
    .contact__details__social {
      margin: 10px 0;
      @include breakpoint(sm) {
        margin: 25px 0;
        display: flex;
        justify-content: center;
      }
      li {
        float: left;
        margin-right: 15px;
        a {
          svg {
            transition: fill .2s ease-in-out;
            height: 15px;
            fill: $sage;
            @include breakpoint(sm) {
              height: 20px;
            }
          }
          &:hover {
            svg {
              fill: darken($sage, 10%);
            }
          }
        }
      }
    }
  }
}
</style>
